module.exports = __webpack_public_path__ + "img/dashboard-profile.4f82a239.svg";